import React, { FunctionComponent } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Main } from './components/Main';

const App: FunctionComponent = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Header />
            <Main />
            <Footer />
        </ThemeProvider>
    );
};

export default App;
